module.exports = {"410581001":"开元街道","410581002":"振林街道","410581003":"龙山街道","410581004":"桂园街道","410581101":"合涧镇","410581102":"临淇镇","410581103":"东姚镇","410581104":"横水镇","410581105":"河顺镇","410581106":"任村镇","410581107":"姚村镇","410581108":"陵阳镇","410581109":"原康镇","410581110":"五龙镇","410581111":"采桑镇","410581112":"东岗镇","410581113":"桂林镇","410581114":"茶店镇","410581115":"石板岩镇","410581116":"黄华镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410581.json
// module id = 1575
// module chunks = 0